import React from 'react';
import FeedContentItem, {
	FeedContentItemProps,
} from '@components/report/content-items/feed-content-item/FeedContentItem';
import NoDataSection from '@components/report/no-data-section/NoDataSection';

import { lackOfPermissionClass } from '@components/report/style.css';

import SnapCarousel from '@shared/snap-carousel/SnapCarousel';

export interface FeedContentProps {
	items?: FeedContentItemProps[];

	isLoading?: boolean;
	isError?: boolean;
	lackOfPermission?: boolean;
}

const FeedContent = ({
	isLoading,
	isError,
	lackOfPermission,
	...props
}: FeedContentProps) => {
	const status = { isLoading, isError, lackOfPermission };
	const available = !isLoading && !isError && !lackOfPermission;
	const items = !available
		? new Array(20).fill({} as FeedContentItemProps)
		: props.items ?? [];

	if (!available || (available && items.length > 0))
		return (
			<SnapCarousel
				className={lackOfPermission ? lackOfPermissionClass : ''}
				items={items?.map((item, idx) => (
					<FeedContentItem key={idx} idx={idx} {...item} {...status} />
				))}
			/>
		);
	else return <NoDataSection />;
};

export default FeedContent;
